export enum EPaymentMethodsState {
  INIT = 'INIT',
  SETUP = 'SETUP',
}

export interface IPaymentMethodsSettings {
  manual: {
    id: number;
    iban: string | null;
  } | null;
  wallet: {
    id: number;
    address: string;
    is_active: boolean;
    allow_incoming_payments: boolean;
  } | null;
}

export interface AddManualPaymentPayload {
  company_id: number;
  iban: string;
}

export interface UpdateManualPaymentPayload extends AddManualPaymentPayload {
  id: number;
}
